import StoreOverview from 'components/storeOverview';
const StoreOverviewPage = () => {
  return <StoreOverview />;
};

export default StoreOverviewPage;
